import React from 'react'
const ArrowRightSvg = ({ style, className, color = 'white' }) => (
  <svg style={style} className={className} width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 10.5L5.5 5.5L0.5 0.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
export default ArrowRightSvg
